module.exports = __webpack_public_path__ + "static/LGS-mobile-b735c2e12fc3245ea158a286d2e7e7d2.png";